module.exports = __webpack_public_path__ + "img/icon_bell_notification_ting_pink.4d91a4c3.svg";